import script from "./remote-client-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./remote-client-dialog.vue?vue&type=script&setup=true&lang=js"

import "./remote-client-dialog.vue?vue&type=style&index=0&id=1c06f455&scoped=true&lang=css"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c06f455"]])

export default __exports__